import { useContext } from 'react'
import { Navigate } from 'react-router-dom'

import { AppContext } from '/providers/app-context'
import PageWrapper from '/components/page-wrapper'
import Menu from '/components/statistics/nav-menu'
import HelpText from '/help/statistics-details'

const PageShell = ({ title, heading, children, helpText: PageHelpText = HelpText }) => {
  const { user } = useContext(AppContext)

  if (user?.permissions.client_admin) {
    return (
      <PageWrapper title={title} HelpText={PageHelpText} heading={heading} menu={<Menu />}>
        <div className='flex flex-col w-full h-full overflow-y-auto pb-20'>
          {children}
        </div>
      </PageWrapper>
    )
  }

  return <Navigate to="/" replace />
}

export default PageShell
